// extracted by mini-css-extract-plugin
export default {"container":"style_container__BSyS1","information":"style_information__+EUuh","dateWrapper":"style_dateWrapper__Izi5K","field":"style_field__aFPbM"};